import ConfigurationMobile from '@/agilis/mobile/util/ConfigurationMobile'
import Configuration from '@/agilis/util/Configuration'
import FormDivider from '@/agilis/components/Form/FormDivider/FormDivider.vue'
import EntityDetails from '@/agilis/components/EntityDetails/EntityDetails'

export default {
  name: 'EntityDetailsMobile',
  mixins: [EntityDetails],
  components: { FormDivider },
  inject: ['provideTrackerDTO', 'provideConfiguration', 'provideSelectedContext', 'provideJlAssertionContext'],
  computed: {
    trackerDTOComputed () {
      return this.provideTrackerDTO
    },
    jlAssertionContext () {
      return this.provideJlAssertionContext
    },
    formRowsForViewMobile () {
      return ConfigurationMobile.detailGrid.getGrid(this.provideConfiguration?.mobile?.detailsLayout) || []
    },
    formFields () {
      const formColumns = this.provideConfiguration?.columns || {}
      const formElements = Object.entries(this.provideConfiguration?.formElements || {}).reduce((acc, [key, value]) => {
        if (value.type === 'divider') {
          return {
            ...acc,
            [key]: value
          }
        }
        return acc
      }, {})
      return {
        ...formColumns,
        ...formElements
      }
    }
  },
  methods: {
    userCanAccessField (colId) {
      return Configuration.auth.userCanAccessField(this.provideSelectedContext, colId, null, 'get')
    }
  }
}
